module.exports = __webpack_public_path__ + "img/banner.885202d1.jpg";